export default __webpack_public_path__ + "static/media/004-placeholder.33148228.png";